var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-hover", {
    attrs: { "open-delay": "100" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ hover }) {
          return [
            _c(
              "v-btn",
              {
                staticClass: "border",
                class: [
                  _vm.textColor,
                  _vm.textHover,
                  _vm.bgHover,
                  _vm.borderColor,
                ],
                attrs: {
                  elevation: hover ? 8 : 0,
                  outlined: "",
                  color: _vm.color,
                  block: _vm.block,
                  large: _vm.large,
                  rounded: _vm.rounded,
                },
              },
              [_vm._v(_vm._s(_vm.text))]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }